import * as CL from '@design-system/component-library';

import { Dropdown } from '../../../common/react-hook-form/components/Dropdown';
import { PhoneNumber } from '../../../common/react-hook-form/fields';
import {
  type ReachabilityWithMobileFormValues,
  busyActionOptions,
  calloutTimeOptions,
  resolveBusyActionLocalization,
} from '../../PbxAccordionContent/PbxAccordionUtils';
import { SelectRadio } from '../../../common/react-hook-form/components/SelectRadio';
import { dsClass } from '../../../common/constants/dsClasses';
import { t } from '../../../common/i18n';

interface MobileCallDetailsProps {
  edit: boolean;
  showConnectToNumber?: boolean;
  addonAttributes?: ReachabilityWithMobileFormValues;
}

export const MobileCallDetails = ({
  edit,
  addonAttributes = {},
  showConnectToNumber = false,
}: MobileCallDetailsProps) =>
  edit ? (
    <CL.Grid className={dsClass.PADDING_TOP_6}>
      <CL.GridRow>
        <CL.GridCol colsXS={4} colsS={6} colsM={3} colsL={6} colsXL={6}>
          <SelectRadio name="busyAction" items={busyActionOptions()} label={t.MW58('When respondent is busy')} />
          {showConnectToNumber && <PhoneNumber name="connectToNumber" label="" required={showConnectToNumber} />}
        </CL.GridCol>
        <CL.GridCol className={`${dsClass.PADDING_BOTTOM_2}`} colsXS={4} colsS={6} colsM={3} colsL={6} colsXL={6}>
          <div className={`${dsClass.MARGIN_BOTTOM_2} ${dsClass.DISPLAY_FLEX}`}>
            <label className={dsClass.INPUT_LABELAREA_LABEL} htmlFor="delayForChainCalls">
              {t.NG9B('Callout time')}
            </label>
            <CL.Tooltip
              triggerElement={
                <CL.Icon className="custom-icon" color="secondary-blue-600" icon="information" size="s" />
              }
              placement="top"
              i18n_tooltip_contentText={t.P04G('Define how long a call rings on a single respondent.')}
            />
          </div>
          <Dropdown name="delayForChainCalls" id="delayForChainCalls" optional={false} items={calloutTimeOptions()} />
        </CL.GridCol>
      </CL.GridRow>
    </CL.Grid>
  ) : (
    <CL.Grid className={dsClass.PADDING_TOP_6}>
      <CL.GridRow>
        <CL.GridCol colsXS={4} colsS={6} colsM={3} colsL={6} colsXL={6}>
          <label className={dsClass.INPUT_LABELAREA_LABEL}>{t.MW58('When respondent is busy')} </label>
          <div className={`${dsClass.PADDING_TOP_1} ${dsClass.PADDING_BOTTOM_1}`}>
            {resolveBusyActionLocalization(addonAttributes.busyAction, addonAttributes.connectToNumber)}
          </div>
        </CL.GridCol>
        <CL.GridCol colsXS={4} colsS={6} colsM={3} colsL={6} colsXL={6}>
          <div className={`${dsClass.PADDING_BOTTOM_1} ${dsClass.DISPLAY_FLEX} ${dsClass.ALIGN_ITEMS_CENTER} `}>
            <label className={dsClass.INPUT_LABELAREA_LABEL}>{t.NG9B('Callout time')}</label>
            <CL.Tooltip
              triggerElement={
                <CL.Icon className="custom-icon" color="secondary-blue-600" icon="information" size="s" />
              }
              placement="top"
              i18n_tooltip_contentText={t.P04G('Define how long a call rings on a single respondent.')}
            />
          </div>
          <div className={`${dsClass.PADDING_TOP_1} ${dsClass.PADDING_BOTTOM_1}`}>
            {`${addonAttributes.delayForChainCalls} s`}
          </div>
        </CL.GridCol>
      </CL.GridRow>
    </CL.Grid>
  );
